import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/genetestapply',
        name: 'genetestapply',
        component: () => import('../views/GeneTestApply.vue')
    },
    {
        path: '/reportsearch',
        name: 'reportsearch',
        component: () => import('../views/ReportSearch.vue')
    },
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/htmlpanel',
        name: 'htmlpanel',
        component: () => import('../views/HtmlPanel.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/regist',
        name: 'regist',
        component: () => import('../views/Regist.vue')
    },
    {
        path: '/immunohematologytestapply',
        name: 'immunohematologytestapply',
        component: () => import('../views/ImmunoHematologyTestApply.vue')
    },
    {
        path: '/edit',
        name: 'edit',
        component: () => import('../views/Edit')
    },
    {
        path: '/myapply',
        name: 'myapply',
        component: () => import('../views/MyApply')
    },
    {
        path: '/usermanage',
        name: 'usermanage',
        component: () => import('../views/UserManage')
    },
    {
        path: '/mychargebill',
        name: 'mychargebill',
        component: () => import('../views/MyChargeBill')
    },
    {
        path: '/myreport',
        name: 'myreport',
        component: () => import('../views/MyReport')
    },
    {
        path: '/paternitytest',
        name: 'paternitytest',
        component: () => import('../views/PaternityTest')
    },
    {
        path: '/paternitytestformobile',
        name: 'paternitytestformobile',
        component: () => import('../views/PaternityTestForMobile')
    },
    {
        path: '/myappointment',
        name: 'myappointment',
        component: () => import('../views/MyAppointment')
    },
    {
        path: '/loginforcheckcode',
        name: 'loginforcheckcode',
        component: () => import('../views/LoginForCheckCode')
    },
    {
        path: '/transfusionfeedback',
        name: 'transfusionfeedback',
        component: () => import('../views/TransfusionFeedback')
    },
    {
        path: '/mytransfusionfeedback',
        name: 'mytransfusionfeedback',
        component: () => import('../views/MyTransfusionFeedback')
    },
    {
        path: '/transfusionreaction',
        name: 'transfusionreaction',
        component: () => import('../views/TransfusionReaction.vue')
    },
    {
        path: '/mytransfusionreaction',
        name: 'mytransfusionreaction',
        component: () => import('../views/MyTransfusionReaction')
    },
    {
        path: '/specialplatelettestapply',
        name: 'specialplatelettestapply',
        component: () => import('../views/SpecialPlateletTestApply.vue')
    },
    {
        path: '/plateletreceipt',
        name: 'plateletreceipt',
        component: () => import('../views/PlateletReceipt')
    },
    {
        path: '/marrowreceipt',
        name: 'marrowreceipt',
        component: () => import('../views/MarrowReceipt')
    },
    {
        path: '/samplereceipt',
        name: 'samplereceipt',
        component: () => import('../views/SampleReceipt')
    }
];

const router = new VueRouter({
    routes
});

export default router
